import offerMealModalActions from "../store/web/offerMealModal/action-types";

function webBulmaModalOpen($element)
{
    $element.addClass('is-active');
    $('html').addClass('is-clipped');

    let imageUrl = $element.data('image');
    if (imageUrl) {
        let img = $('<img />', {
            src: imageUrl,
            alt: ''
        });
        img.appendTo($('.modal-image', $element));
        $element.data('image', '');
    }
}

$('.tooltip').on({ 'touchstart' : function(){
        $(this).addClass('is-tooltip-active');
    } });

$('.tooltip').on({ 'touchend' : function(){
        $(this).removeClass('is-tooltip-active');
    } });

// zavreni modalu
$('.modal-background,.modal-close').click(function () {
    $('.modal').removeClass('is-active');
    $('html').removeClass('is-clipped');
});

// otevreni modalu
$('[data-modal-open]').click(function () {
    if (!$(this).hasClass('image-items__image')) {
        webBulmaModalOpen($($(this).data('modal-open')));
    } else if (window.innerWidth >= 769) {
        webBulmaModalOpen($($(this).data('modal-open')));
    }
});

// zavereni po kliku na obrazek
$('.modal .modal-content.is-image img').click(function () {
    $('.modal').removeClass('is-active');
    $('html').removeClass('is-clipped');
});

import store from '../store/web';

// zavreni modalu pomoci ESC
$(document).keydown(function(e) {
    if (e.keyCode === 27) { // escape key maps to keycode `27`
        $('.modal').removeClass('is-active');
        $('html').removeClass('is-clipped');
        store.dispatch('offerMealModal/' + offerMealModalActions.HIDE);
    }
    if (e.keyCode === 37) {
        let $currentModal = $('.modal.is-active');
        if ($currentModal.length) {
            $currentModal.removeClass('is-active');
            let $prevModal = $currentModal.prev('.modal');
            if ($prevModal.length) {
                webBulmaModalOpen($prevModal);
            } else {
                webBulmaModalOpen($currentModal.siblings('.modal').last());
            }
        }
    }
    if (e.keyCode === 39) {
        let $currentModal = $('.modal.is-active');
        if ($currentModal.length) {
            $currentModal.removeClass('is-active');
            let $nextModal = $currentModal.next('.modal');
            if ($nextModal.length) {
                webBulmaModalOpen($nextModal);
            } else {
                webBulmaModalOpen($currentModal.siblings('.modal').first());
            }
        }
    }
});

$('.has-dropdown').click(function(){
   $(this).toggleClass('is-active');
});
